import type { Readiness } from './prima-nota-model';

export type Verdict = 'blocked' | 'warnings' | 'ready';

function verdictOf(generable: boolean, findingCount: number): Verdict {
  if (!generable) {
    return 'blocked';
  }
  return findingCount > 0 ? 'warnings' : 'ready';
}

/** What the page reads off the month's readiness, by the same rules the buttons use. */
export function deriveReadiness(data: Readiness) {
  const blocking = data.gaps.filter((gap) => gap.blocking);
  // «Genera» asks nexpense first, so a month whose ONLY blocking gap is the missing documents file
  // can be generated when the export will supply it. Any other blocking gap stays blocking: the
  // refresh would run, replace the documents file, and end in a refusal anyway.
  const generable =
    data.canGenerate ||
    (data.fiscalExportConfigured === true &&
      blocking.length > 0 &&
      blocking.every((gap) => gap.code === 'fiscal-workbook-absent'));
  const advisory = data.gaps.filter((gap) => !gap.blocking);
  const live = data.sources.filter((source) => source.withdrawnAt === null);
  const documentsSupplied = live.some((source) => source.kind === 'fiscal-workbook');

  // The month's state, for the sentence and both badges, read from the same rule the button uses:
  // a badge must never say «Bloccata» beside a «Genera» that works, which is the ordinary start of
  // a month when nexpense will fetch the documents file. The reminder the server adds to every
  // month (`period-judgement-required`) is an instruction about the confirmation, not a finding
  // about the month, so it does not turn a ready month amber.
  const findings = advisory.filter((gap) => gap.code !== 'period-judgement-required');
  const fromNexpense = generable && blocking.length > 0;
  const verdict = verdictOf(generable, findings.length);

  return { generable, documentsSupplied, findings, fromNexpense, verdict };
}
